export * from './resizable.module';
export { BoundingRectangle } from './interfaces/bounding-rectangle.interface';
export { Edges } from './interfaces/edges.interface';
export { ResizeEvent } from './interfaces/resize-event.interface';
export { ResizableDirective } from './resizable.directive';
export { ResizeHandleDirective } from './resize-handle.directive';
